import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRatewareTariffCodeMaintenance extends Layout {
    buttonAddChargeType: Button;
    panelTariffInfo: Panel;
    sourceRatewareTariffCodeMasterfile: DataSource;
    textboxRatewareProductInfo: Textbox;
    textboxRatewareTariffDate: Textbox;
    textboxRatewareTariffName: Textbox;
    textboxTariffSelection: Textbox;
    textboxTliCalcUomCode: Textbox;
}
